import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobs: {},
};

const mintSlice = createSlice({
  name: "mint",
  initialState,
  reducers: {
    upsertMintJob: (state, action) => {
      const { propertyId, jobId } = action.payload || {};
      if (!propertyId || !jobId) {
        return;
      }
      state.jobs[propertyId] = {
        ...(state.jobs[propertyId] || {}),
        ...action.payload,
        updatedAt: action.payload.updatedAt || new Date().toISOString(),
      };
    },
    removeMintJob: (state, action) => {
      const propertyId = action.payload;
      if (propertyId && state.jobs[propertyId]) {
        delete state.jobs[propertyId];
      }
    },
    resetMintState: () => initialState,
  },
});

export const { upsertMintJob, removeMintJob, resetMintState } =
  mintSlice.actions;

export default mintSlice.reducer;



